import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import {
    ConfigurationDepartmentCreateRequest,
    ConfigurationDepartmentPatchInBatchRequest,
    ConfigurationDepartmentResponse
} from '@/modules/configurationModule/detail/automation/notifications/automation-notifications-case/services/configuration-department/configuration-department.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationDepartmentService {
    async create(request: ConfigurationDepartmentCreateRequest): Promise<ConfigurationDepartmentResponse> {
        const response = await axios.post<ConfigurationDepartmentResponse>(`/configuration/departments`, request)
        return response.data
    }

    async paginator(filterModel?: CommonFilterModel, params?: CommonParams): Promise<IResponseAgGrid<ConfigurationDepartmentResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationDepartmentResponse>>(`/configuration/departments/`, { ...filterModel }, { params })
        return response.data
    }

    async get(departmentId: number): Promise<ConfigurationDepartmentResponse> {
        const response = await axios.get<ConfigurationDepartmentResponse>(`/configuration/departments/${departmentId}`)
        return response.data
    }

    async delete(request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/departments/batch`, { data: request })
        return response.data
    }

    async patch(request: ConfigurationDepartmentPatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/departments/batch`, request)
        return response.data
    }
}

export const configurationDepartmentService = new ConfigurationDepartmentService()
